/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Createorganization2Inputs */

const zh_organizationsettings_createorganization2 = /** @type {(inputs: Organizationsettings_Createorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建组织`)
};

const en_organizationsettings_createorganization2 = /** @type {(inputs: Organizationsettings_Createorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create organization`)
};

const es_organizationsettings_createorganization2 = /** @type {(inputs: Organizationsettings_Createorganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear organización`)
};

/**
* | output |
* | --- |
* | "Create organization" |
*
* @param {Organizationsettings_Createorganization2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_createorganization2 = /** @type {((inputs?: Organizationsettings_Createorganization2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Createorganization2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_createorganization2(inputs)
	if (locale === "en") return en_organizationsettings_createorganization2(inputs)
	return es_organizationsettings_createorganization2(inputs)
});
export { organizationsettings_createorganization2 as "organizationSettings_createOrganization" }